import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import { IGatsbyChildImageSharp } from '@et/types/Gatsby'
import { IMAGELOADINGENUMS } from '@et/types/Enums'

interface IProps {
  gatsbyImage: IGatsbyChildImageSharp
  fade?: boolean
  critical?: IMAGELOADINGENUMS | undefined,
  classes?: string,
  alt?: string
}

const ImgSmall = ({ gatsbyImage, fade = true, critical = IMAGELOADINGENUMS.AUTO, classes = '', alt = 'Every-Tuesday Image' }: IProps) => (
  <Img
    fadeIn={fade}
    loading={critical}
    alt={alt}
    className={classes}
    fluid={gatsbyImage.childImageSharp.fluid}
  />
)

export default ImgSmall
